// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8a80468cbeb9e4b9f29da6324f435464b8b1c620/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};